angular.module('common.template.footnotes.popup',['common.filter.description', 'common.filter.specialCharacterToHtml']).controller('FootnotesPopupController',
    function($uibModalInstance, measureFootnotes, commodityCode){
        var footnotesPopupCtrl = this;
        footnotesPopupCtrl.measureFootnotes = measureFootnotes;
        footnotesPopupCtrl.commodityCode = commodityCode;

        footnotesPopupCtrl.close = function (){
            $uibModalInstance.dismiss('Close');
        };
    });


// WEBPACK FOOTER //
// ./app/common/popup/footnotes/footnotes-popup.js